export const AUTH_TOKEN = "auth_token";
export const AUTH_UID = "AUTH_UID";
export const PHOTO_URL = "photoUrl";
export const USER_NAME = "name";
export const USER_EMAIL = "email";
